@import "../../../global/temporary-mercury-overrides/_button.scss";

:host {
  display: grid;
  block-size: 100%;
  grid-template-rows: 1fr max-content;
}

.commit-date-container,
.commit-number-container {
  display: grid;
  gap: var(--spacing-gap-xl);
}

.commit-date-container {
  grid-template-rows: max-content max-content max-content max-content;
}

.commit-number-container {
  grid-template-rows: max-content max-content max-content;
}

.heading {
  margin-block: 0;
}

.tooltip {
  position: absolute;
}
